import { defineMessages } from 'react-intl';

export default defineMessages({
  resendVerificationCodeSuccessTitle: {
    id: 'account.creation.confirmation.email.sent.title',
    defaultMessage: 'Email sent',
  },
  resendVerificationCodeSuccessDesc: {
    id: 'account.creation.confirmation.email.sent.desc',
    defaultMessage: 'We sent you another verification code',
  },
  resendVerificationCodeFailureTitle: {
    id: 'account.creation.confirmation.email.error.title',
    defaultMessage: 'Error',
  },
  resendVerificationCodeFailureDesc: {
    id: 'account.creation.confirmation.email.error.body',
    defaultMessage: 'We couldn’t send the verification code. Please try again.',
  },
});
